
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Control } from "@/types/controls";
import Copyable from "./Copyable.vue";
import {
  codeForControls,
  wrapWithCondition
} from "@/lib/element-studio/twig-code-helper";
import { addHoverToPath } from "@/lib/controls/utils";

@Component({
  components: {
    Copyable
  }
})
export default class TwigCodeHelper extends Vue {
  @Prop()
  control!: Control;

  @Prop()
  twigParentPath!: string;

  @Prop()
  inRepeater!: boolean;

  get twigPath() {
    return this.inRepeater
      ? `item.${this.control.slug}`
      : `${this.twigParentPath}.${this.control.slug}`;
  }

  get codeForControl() {
    const getHelperCodeForControl = codeForControls[this.control.options.type];

    // TODO eventually we should have all presets in element studio
    // so we can get rid of the "section" part of codeForControls
    const codeHelpFromPreset =
      this.control.options.sectionOptions?.preset?.codeHelp?.replace(
        "%%TWIG_PATH%%",
        this.twigPath
      );

    let helperCode =
      codeHelpFromPreset ||
      (getHelperCodeForControl &&
        getHelperCodeForControl({
          control: this.control,
          twigPath: this.twigPath
        }));

    if (!helperCode) return false;

    if (this.control.options.condition) {
      helperCode = wrapWithCondition(
        this.control.options.condition,
        helperCode
      );
    }

    if (this.control.enableHover) {
      const hoverCode = helperCode.replace(
        new RegExp(this.twigPath, "g"),
        addHoverToPath(this.twigPath)
      );

      helperCode += "\n\n.some-selector:hover {\n" + hoverCode + "\n}\n";
    }

    return helperCode;
  }

  close() {
    this.$emit("close");
  }
}
